Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = exports.SDK_NAME = void 0;
exports.SDK_NAME = 'sentry.javascript.cordova';
exports.SDK_VERSION = '1.0.4';
